import React from "react";
import { Box } from "@mui/material";

const SecureImage = ({ src, alt, height = 160 }) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height,
        borderRadius: 1,
        overflow: "hidden",
        userSelect: "none",
      }}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    >
      {/* Image */}
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          display: "block",
          pointerEvents: "none",
        }}
      />

      {/* Watermark Pattern */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "repeating-linear-gradient(-30deg, rgba(0,0,0,0.08) 0, rgba(0,0,0,0.08) 120px, transparent 120px, transparent 240px)",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      {/* Watermark Text Grid */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gridTemplateRows: "repeat(3, 1fr)",
          placeItems: "center",
          fontSize: 13,
          fontWeight: 700,
          color: "rgba(0,0,0,0.18)",
          transform: "rotate(-25deg)",
          zIndex: 2,
          pointerEvents: "none",
          textAlign: "center",
        }}
      >
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i}>FOR VERIFICATION ONLY</span>
        ))}
      </Box>
    </Box>
  );
};

export default SecureImage;
